export const FormErrorsDE = {
  invalidEmail: "Die E-Mail-Adresse ist ungültig. (example@mail.com)",
  invalidUrl: "Die URL ist ungültig. (https://example.com)",
};
